import { useEffect, useMemo, useState, useCallback } from "react";

import styled from "styled-components";
// import { Container, Snackbar } from '@material-ui/core';
// import Paper from '@material-ui/core/Paper';
// import Alert from '@material-ui/lab/Alert';
import { AlertState } from "./utils";
import { MintCountdown } from "./MintCountdown";
import { Button, Row, Col, Grid } from "antd";
import VideoModal from "./VideoModal";

const { useBreakpoint } = Grid;

// const ConnectButton = styled(WalletMultiButton)`
//   width: 100%;
//   height: 100%;
//   margin-top: 10px;
//   margin-bottom: 5px;
//   background: #3CE6DB;
//   color: white;
//   font-size: 40px;
//   font-family: Orbitron;
//   font-weight: bold;
// `;

// const ConnectButtonShow = styled(WalletMultiButton)`
//   border-radius: 18px !important;
//   padding: 6px 16px;
//   background-color: #4E44CE;
//   margin: 0 auto;
// `;

const MintContainer = styled.div``; // add your owns styles here
const WalletContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: right;
`;

const WalletAmount = styled.div`
  color: black;
  width: auto;
  padding: 5px 5px 5px 16px;
  min-width: 48px;
  min-height: auto;
  border-radius: 22px;
  background-color: var(--main-text-color);
  box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%),
    0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 500;
  line-height: 1.75;
  text-transform: uppercase;
  border: 0;
  margin: 0;
  display: inline-flex;
  outline: 0;
  position: relative;
  align-items: center;
  user-select: none;
  vertical-align: middle;
  justify-content: flex-start;
  gap: 10px;
`;

const Wallet = styled.ul`
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
`;

const Home = (props: any) => {
  const now_time = new Date();
  const mint_time = new Date("May 22, 2022, 14:00 UTC");
  const end_time = new Date("May 23, 2022 2:00 UTC");

  const isMobile = useBreakpoint().xs;
  const [isUserMinting, setIsUserMinting] = useState(false);
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: "",
    severity: undefined,
  });

  const [isActive, setIsActive] = useState(false);
  const [endDate, setEndDate] = useState<Date>();
  const [itemsRemaining, setItemsRemaining] = useState<number>();
  const [isWhitelistUser, setIsWhitelistUser] = useState(false);
  const [isPresale, setIsPresale] = useState(false);
  const [needTxnSplit, setNeedTxnSplit] = useState(true);
  const [balance, setBalance] = useState<number>();
  const [isEnded, setIsEnded] = useState(false);
  const [isSoldOut, setIsSoldOut] = useState(false);
  const [whitelistTokenBalance, setWhitelistTokenBalance] = useState(0);
  const [isWLOnly, setIsWLOnly] = useState(false);

  const [isBurnToken, setIsBurnToken] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [videoModalVisible, setVideoModalVisible] = useState(false);

  const renderButton = () => {
    if (
      mint_time.getTime() <= now_time.getTime() &&
      now_time.getTime() <= end_time.getTime()
    ) {
      return (
        <Row justify="center">
          <Col xs={24} sm={22} md={16} lg={14} xl={12}>
            <a
              href="https://www.fractal.is/neopetsmeta"
              target="_blank"
              rel="noreferrer"
            >
              <Button style={styles.btn}>
                <Row align="middle" justify="center" style={{ height: "100%" }}>
                  <Col>
                    <img
                      src="/solana_icon.png"
                      style={{
                        width: 40,
                        marginRight: 20,
                        height: "100%",
                        objectFit: "contain",
                      }}
                      alt="icon"
                    />
                  </Col>
                  <Col style={{ padding: isMobile ? "10px 0px" : "10px 0px" }}>
                    <span
                      style={{
                        color: "#fff",
                        fontSize: isMobile ? 24 : 30,
                        fontWeight: "bold",
                      }}
                    >
                      Mint now on Fractal!
                    </span>
                  </Col>
                </Row>
              </Button>
            </a>
          </Col>
        </Row>
      );
    }

    return null;
  };

  const renderDescription = () => {
    // event is end
    if (end_time.getTime() < now_time.getTime()) {
      return (
        <Col
          xs={{ span: 24, order: 1 }}
          sm={{ span: 24, order: 1 }}
          md={{ span: 24, order: 1 }}
          lg={{ span: 16, order: 0 }}
        >
          <div
            style={{
              fontFamily: "Orbitron",
              fontWeight: "700",
              color: "#3CE6DB",
              marginBottom: 32,
            }}
          >
            {isMobile ? (
              <img
                src="/title_mobile.svg"
                alt="Pizzaroo’s Unique Pizzas"
                style={{ objectFit: "contain" }}
                width={"100%"}
                height={"100%"}
              />
            ) : (
              <img
                src="/title.svg"
                alt="Pizzaroo’s Unique Pizzas"
                style={{ objectFit: "contain" }}
                width={"100%"}
                height={"100%"}
              />
            )}
          </div>
          <p
            style={{
              color: "#fff",
              fontFamily: "Comfortaa",
              fontWeight: "600",
              fontSize: 20,
            }}
          >
            Thank you all for your participation! Our mint is over, but we hope
            you all enjoyed your delicious pizzas!
          </p>
          <p
            style={{
              color: "#fff",
              fontFamily: "Comfortaa",
              fontWeight: "600",
              fontSize: 20,
            }}
          >
            Holders of Pizzaroo's Pizzas will so far be able to enjoy:
            <br />
            - Allowlist into Neopets Metaverse private alpha testing
            <br />
            - A special limited edition in-game item within the Neopets
            Metaverse
            <br />- Verifiable role to access a private channel within our
            Discord
          </p>
          <p
            style={{
              color: "#fff",
              fontFamily: "Comfortaa",
              fontWeight: "600",
              fontSize: 20,
            }}
          >
            More perks, drops and utilities to be announced in the future!
          </p>
        </Col>
      );
    }

    // starting
    if (now_time.getTime() >= mint_time.getTime()) {
      return (
        <Col
          xs={{ span: 24, order: 1 }}
          sm={{ span: 24, order: 1 }}
          md={{ span: 24, order: 1 }}
          lg={{ span: 16, order: 0 }}
        >
          <div
            style={{
              fontFamily: "Orbitron",
              fontWeight: "700",
              fontSize: 48,
              color: "#3CE6DB",
              marginBottom: 32,
            }}
          >
            {isMobile ? (
              <img
                src="/title_mobile.svg"
                alt="Pizzaroo’s Unique Pizzas"
                style={{ objectFit: "contain" }}
                width={"100%"}
                height={"100%"}
              />
            ) : (
              <img
                src="/title.svg"
                alt="Pizzaroo’s Unique Pizzas"
                style={{ objectFit: "contain" }}
                width={"100%"}
                height={"100%"}
              />
            )}
          </div>
          <p
            style={{
              color: "#fff",
              fontFamily: "Comfortaa",
              fontWeight: "600",
              fontSize: 20,
            }}
          >
            In celebration of Crypto Pizza Day and the reveal of our first game
            trailer, Neopets Metaverse presents a collection of{" "}
            <span style={{ fontWeight: "700", color: "#FEF301" }}>5,000</span>{" "}
            unique Neopets-inspired pizza NFTs freshly baked from the oven on
            Solana. It is now available to mint on{" "}
            <a
              href="https://www.fractal.is/neopetsmeta"
              target="_blank"
              rel="noreferrer"
            >
              <span
                style={{
                  fontWeight: "700",
                  color: "#FEF301",
                  textDecoration: "underline",
                }}
              >
                Fractal
              </span>
            </a>
            , the first gaming-focused NFT marketplace.
          </p>
          <p
            style={{
              color: "#fff",
              fontFamily: "Comfortaa",
              fontWeight: "600",
              fontSize: 20,
            }}
          >
            Available as a{" "}
            <span style={{ fontWeight: "700", color: "#FEF301" }}>FREE</span>{" "}
            mint for token holders of popular blockchain projects, our pizza
            collection ranges from the most appetizing and scrumptious-looking
            to the downright weird!
          </p>
          <p
            style={{
              color: "#FEF301",
              fontFamily: "Comfortaa",
              fontWeight: "600",
              fontSize: 20,
            }}
          >
            So mint now on{" "}
            <a
              href="https://www.fractal.is/neopetsmeta"
              target="_blank"
              rel="noreferrer"
            >
              <span
                style={{
                  fontWeight: "700",
                  color: "#FEF301",
                  textDecoration: "underline",
                }}
              >
                Fractal
              </span>
            </a>{" "}
            and view our{" "}
            <span
              style={{
                fontSize: 22,
                fontWeight: "700",
                fontFamily: "Orbitron",
              }}
            >
              game trailer{" "}
            </span>
            !
          </p>
        </Col>
      );
    }

    // not start
    return (
      <Col
        xs={{ span: 24, order: 1 }}
        sm={{ span: 24, order: 1 }}
        md={{ span: 24, order: 1 }}
        lg={{ span: 16, order: 0 }}
      >
        <div
          style={{
            fontFamily: "Orbitron",
            fontWeight: "700",
            fontSize: 48,
            color: "#3CE6DB",
            marginBottom: 32,
          }}
        >
          {isMobile ? (
            <img
              src="/title_mobile.svg"
              alt="Pizzaroo’s Unique Pizzas"
              style={{ objectFit: "contain" }}
              width={"100%"}
              height={"100%"}
            />
          ) : (
            <img
              src="/title.svg"
              alt="Pizzaroo’s Unique Pizzas"
              style={{ objectFit: "contain" }}
              width={"100%"}
              height={"100%"}
            />
          )}
        </div>
        <p
          style={{
            color: "#fff",
            fontFamily: "Comfortaa",
            fontWeight: "600",
            fontSize: 20,
          }}
        >
          In celebration of Crypto Pizza Day and the reveal of our first game
          trailer, Neopets Metaverse presents a collection of{" "}
          <span style={{ fontWeight: "700", color: "#FEF301" }}>5,000</span>{" "}
          unique Neopets-inspired pizza NFTs freshly baked from the oven on
          Solana. It will be available to mint on{" "}
          <a
            href="https://www.fractal.is/neopetsmeta"
            target="_blank"
            rel="noreferrer"
          >
            <span
              style={{
                fontWeight: "700",
                color: "#FEF301",
                textDecoration: "underline",
              }}
            >
              Fractal
            </span>
          </a>
          , the first gaming-focused NFT marketplace.
        </p>
        <p
          style={{
            color: "#fff",
            fontFamily: "Comfortaa",
            fontWeight: "600",
            fontSize: 20,
          }}
        >
          Available as a{" "}
          <span style={{ fontWeight: "700", color: "#FEF301" }}>FREE</span> mint
          for token holders of popular blockchain projects, our pizza collection
          ranges from the most appetizing and scrumptious-looking to the
          downright weird!.
        </p>
        <p
          style={{
            color: "#FEF301",
            fontFamily: "Comfortaa",
            fontWeight: "600",
            fontSize: 20,
          }}
        >
          Remember to stay tuned for our{" "}
          <span
            style={{ fontSize: 22, fontWeight: "700", fontFamily: "Orbitron" }}
          >
            game trailer{" "}
          </span>{" "}
          and mint our unique pizza NFTs!
        </p>
      </Col>
    );
  };

  return (
    <div
      style={{
        backgroundImage: isMobile ? "url('/bg_mobile.jpg')" : "url('/bg.jpg')",
        minHeight: "100vh",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        paddingBottom: isMobile ? 150 : "10%",
      }}
    >
      <Row justify="center">
        <Col xs={22} md={20}>
          <Row
            gutter={[0, 10]}
            style={{ paddingTop: 20, marginBottom: "8%" }}
            justify={"space-between"}
            align="middle"
          >
            {/* header */}
            <Col xs={10} md={3}>
              <a
                href="https://www.neopetsmeta.io/"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/logo.svg"
                  alt="logo"
                  width={"100%"}
                  height={"100%"}
                />
              </a>
            </Col>
            <Col xs={8} md={3}>
              <a
                href="https://www.fractal.is/neopetsmeta"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="/fractal.svg"
                  alt="logo"
                  width={"100%"}
                  height={"100%"}
                />
              </a>
            </Col>
          </Row>
          {mint_time.getTime() <= now_time.getTime() ? (
            <Row style={{ marginBottom: 62 }}>
              <Col
                span={24}
                style={{
                  fontFamily: "Orbitron",
                  textAlign: "center",
                  fontWeight: "700",
                  fontSize: isMobile ? 28 : 48,
                  color: "#3CE6DB",
                  marginBottom: 32,
                }}
              >
                Welcome to the Neopets Metaverse
              </Col>
              <Col span={24}>
                <img
                  onClick={() => setVideoModalVisible(true)}
                  src="/intro.png"
                  alt="Pizzaroo’s Unique Pizzas Intro"
                  style={{ objectFit: "contain", cursor: "pointer" }}
                  width={"100%"}
                  height={"100%"}
                />
              </Col>
            </Row>
          ) : null}
          <Row style={{ marginBottom: 20 }}>
            {/* Content */}
            <Col span={24}>
              <Row justify={"center"} gutter={[20, 20]}>
                {renderDescription()}
                <Col
                  xs={{ span: 20, order: 0 }}
                  sm={{ span: 20, order: 0 }}
                  md={{ span: 12, order: 0 }}
                  lg={{ span: 8, order: 1 }}
                >
                  <img
                    src="/pizza_bloomaroo.png"
                    alt="pizza_bloomaroo"
                    style={{ objectFit: "contain" }}
                    width={"100%"}
                    height={"100%"}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          {end_time.getTime() < now_time.getTime() ? null : (
            <Row justify="center" align="middle" style={{ marginBottom: 36 }}>
              <Col
                xs={24}
                sm={22}
                md={16}
                lg={14}
                xl={12}
                style={{
                  fontFamily: "Orbitron",
                  fontWeight: "700",
                  fontSize: 36,
                  color: "#FEF301",
                  border: "3px solid #FEF301",
                  borderRadius: 12,
                  textAlign: "center",
                  padding: "4px 0px",
                }}
              >
                May 22, 2022, 14:00 UTC
              </Col>
            </Row>
          )}

          <Row justify="center">
            <Col span={24}>{renderButton()}</Col>
          </Row>
        </Col>
      </Row>

      {/* <Snackbar
        open={alertState.open}
        autoHideDuration={alertState.noHide ? null : 6000}
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar> */}
      <VideoModal
        setModalVisible={setVideoModalVisible}
        modalVisible={videoModalVisible}
      />
    </div>
  );
};

// const getCountdownDate = (
//   candyMachine: CandyMachineAccount,
// ): Date | undefined => {
//   if (
//     candyMachine.state.isActive &&
//     candyMachine.state.endSettings?.endSettingType.date
//   ) {
//     return toDate(candyMachine.state.endSettings.number);
//   }

//   return toDate(
//     candyMachine.state.goLiveDate
//       ? candyMachine.state.goLiveDate
//       : candyMachine.state.isPresale
//         ? new anchor.BN(new Date().getTime() / 1000)
//         : undefined,
//   );
// };

const styles = {
  btn: {
    backgroundColor: "#3CE6DB",
    height: "100%",
    width: "100%",
    borderRadius: 12,
    fontSize: 20,
    color: "#fff",
    fontWeight: "bold",
    fontFamily: "Orbitron",
  },
  successBtn: {
    minHeight: 70,
    width: "100%",
    borderRadius: 12,
    fontSize: 20,
    color: "#fff",
    fontWeight: "bold",
    fontFamily: "Orbitron",
    background:
      "linear-gradient(95.97deg, #BD7AEF 3.45%, #BD7AEF 26.67%, #E9A5D4 53.2%, #D390E2 78.62%, #BD7AEF 104.05%)",
  },
};

export default Home;
